/*
 * @Author: 迟长志 chicz@sqbj.com
 * @Date: 2022-09-23 16:31:22
 * @LastEditors: 迟长志 chicz@sqbj.com
 * @LastEditTime: 2022-09-26 11:20:39
 * @FilePath: /zq/src/page/magicInstrument/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, message, Row, TimePicker, } from 'antd';
import { PlusOutlined, PlusCircleOutlined } from '@ant-design/icons';
import './style.css';

const muyu = require('../../audio/Muyu.mp3');
const zhong = require('../../audio/zhongsheng.mp3');

export class MagicInstrument extends React.Component<any, any>{
    public audioDom: any = {};
    public constructor(props: any) {
        super(props);
        this.state = {
        }
        // this.audio1 = React.createRef();
        // this.audio2 = React.createRef();
    }
    render() {
        // let { query } = this.state;
        return (
            <div className='woodenFish'>
                <div
                    onClick={() => this.audioPlay()}
                >
                    <img src={'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fbkimg.cdn.bcebos.com%2Fpic%2Fcaef76094b36acaf3980f66e76d98d1001e99c3b&refer=http%3A%2F%2Fbkimg.cdn.bcebos.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1666753890&t=0ebd654bb058b4de7853c900a043a6a2'} alt="" className='fo_muyu' />
                </div>
                <div onClick={() => this.audioPlayzhong()}>
                    <img src={'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fwximg1.artimg.net%2Fnews%2F201110%2F2011100815213931445.jpg&refer=http%3A%2F%2Fwximg1.artimg.net&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1666754429&t=4e64e90a1209bc128bba5ed4eba8b91e'} alt="" className='fo_zhong' />
                </div>
                <audio
                    id='muyu'
                    ref={(audio) => {
                        this.audioDom = audio;
                    }}
                    src={muyu.default} controls />
                <audio
                    id='zhong'
                    ref={(audio) => {
                        this.audioDom = audio;
                    }}

                    src={zhong.default} controls />
            </div >
        )
    }

    private audioPlay = () => {
        const audio: any = document.getElementById(`muyu`);
        audio.play();
    }
    private audioPlayzhong = () => {
        const audio: any = document.getElementById(`zhong`);
        audio.play();
    }
}

